<template>
  <div class="space-y-10 divide-y divide-gray-900/10">
    <div class="grid grid-cols-1 gap-x-8 gap-y-8 pt-10 md:grid-cols-3">
      <div class="px-4 sm:px-0">
        <h2 class="text-base font-semibold leading-7 text-gray-900">Question checkpoint</h2>
        <p class="mt-1 text-sm leading-6 text-gray-600">Question checkpoint Text Prompt</p>
      </div>

      <Form v-slot="{ handleSubmit, errors}" :validation-schema="schema" class="bg-white shadow-sm ring-1 ring-gray-900/5 sm:rounded-xl md:col-span-2">
        <button v-if="questionCheckpointId" @click="destroy" type="button" class="rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600 m-3">
          <TrashIcon class="h-5 w-5" aria-hidden="true" />
        </button>
        <div class="px-4 py-6 sm:p-8">
          <div class="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">

            <div class="sm:col-span-5">
              <label for="name" class="block text-sm font-medium leading-6 text-gray-900">Question</label>
              <p class="text-gray-600 text-xs">{{ questionText }}</p>
              <div class="mt-2">
                <input hidden v-model="formData.question_id" type="text" name="question_id" id="question_id" />
              </div>
            </div>

            <div class="col-span-full">
              <label for="about" class="block text-sm font-medium leading-6 text-gray-900">Text</label>
              <div class="mt-2">
                <TrixComponent v-if="editorView" :id="editorId" :text="formData.text" @dataFromTrix="getDataFromTrix"></TrixComponent>
                <Field v-model="formData.text" v-bind:class="{ 'ring-red-600': errors.text }" as="textarea" name="text" id="text" hidden="hidden"/>
                <ErrorMessage class="mt-2 text-xs text-red-600" name="text" />
              </div>
              <p class="mt-3 text-sm leading-6 text-gray-600">Text Prompt</p>
            </div>

          </div>
        </div>
        <div class="flex items-center justify-end gap-x-6 border-t border-gray-900/10 px-4 py-4 sm:px-8">
          <button @click="cancel" type="button" class="text-sm font-semibold leading-6 text-gray-900">Cancel</button>
          <button v-if="questionCheckpointId" @click="handleSubmit($event, update)" type="button" class="rounded-md bg-gray-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-gray-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-600">Update</button>
          <button v-else @click="handleSubmit($event, create)" type="button" class="rounded-md bg-gray-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-gray-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-600">Save</button>
        </div>
      </Form>
    </div>
  </div>
</template>

<script>
import { TrashIcon } from '@heroicons/vue/24/solid'
import TrixComponent from "../TrixComponent.vue";

export default {
  name: "QuestionCheckpointCreateEditFormComponent",
  data() {
    return {
      formData: {
        question_id: null,
        text: null,
      },
      editorId: "text",
      editorView: false,
      questionText: null,
    }
  },
  components: {
    TrixComponent,
    TrashIcon,
  },
  computed: {
    schema() {
      return yup.object({
        text: yup.string().required().min(3).label('Text'),
      });
    },
    questionSetId() {
      return this.$route.params.question_set_id ? parseInt((this.$route.params.question_set_id)) : null;
    },
    questionId() {
      return this.$route.params.question_id ? parseInt((this.$route.params.question_id)) : null;
    },
    questionCheckpointId() {
      return this.$route.params.id ? parseInt((this.$route.params.id)) : null;
    },
  },
  methods: {
    getQuestion() {
      axios.get(`/member-firm/question-set/${this.questionSetId}/question/show/${this.questionId}`).then((res) => {
        this.formData.question_id = res.data.data.id;
        this.questionText = res.data.data.text;
        this.editorView = true;
      }).catch((error) => {
        console.log('error', error)
      })
    },
    getQuestionCheckpoint() {
      axios.get(`/member-firm/question-set/question/${this.questionId}/checkpoint/edit/${this.questionCheckpointId}`).then((res) => {
        this.formData = res.data.data;
      }).catch((error) => {
        console.log('error', error)
      })
    },
    update() {
      axios.put(`/member-firm/question-set/question/${this.questionId}/checkpoint/update/${this.questionCheckpointId}`, this.formData)
          .then((res) => {
            this.$notify({ type: "success", title: "Successfully", text: res.data.message });
            this.$router.back();
          })
          .catch((error) => {
            console.log('error', error);
            this.$notify({ title: "Unsuccessfully", text: error.message });
          });
    },
    create() {
      axios.post(`/member-firm/question-set/question/checkpoint/store`, this.formData)
          .then((res) => {
            this.$notify({ type: "success", title: "Successfully", text: res.data.message });
            this.$router.back();
          })
          .catch((error) => {
            console.log('error', error);
            this.$notify({ title: "Unsuccessfully", text: error.message });
          });
    },
    cancel() {
      this.$router.back();
    },
    destroy() {
      if(confirm("Do you really want to delete?")) {
        axios.delete(`/member-firm/question-set/question/checkpoint/destroy/${this.questionCheckpointId}`).then((res) => {
          this.$router.back();
        }).catch((error) => {
          console.log('error', error)
        })
      }
    },
    getDataFromTrix: function(data) {
      this.formData.text = data;
    },
  },
  created() {
    if(this.questionCheckpointId){
      this.getQuestionCheckpoint();
    } else {
      this.editorView = true;
    }
    this.getQuestion();
  }
}
</script>